import { planningAPI } from "../../axios";

export const state = {
    postedOpcr: [],
    isPostedOpcrLoading: false,
}

export const mutations = {
    SET_POSTED_OPCR(state, data){
        state.postedOpcr = data;
    },
    SET_IS_POSTED_OPCR_LOADING(state, data){
        state.isPostedOpcrLoading = data;
    }
}

export const actions = {

    // Opcr
    GetSingleOpcr(context, data){
        return planningAPI.get(`Opcr/${data}`);
    },
    AddOpcr(context, data){
        return planningAPI.post(`Opcr/Add`, data);
    },
    UpdateOpcr(context, data){
        return planningAPI.put(`Opcr/Update/${data.id}`, data);
    },
    PostOpcr(context, data){
        return planningAPI.post(`Opcr/Post/${data}`);
    },
    ReturnOpcr(context, data){
        return planningAPI.post(`Opcr/Return/${data}`);
    },
    DeleteOpcr(context, data){
        return planningAPI.delete(`Opcr/Remove/${data}`);
    },
    GetAllOpcr(context, data){
        return planningAPI.get(`Opcr/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    getPostedOpcr(context, {campusId, cycle})
    {
        return planningAPI.get(`Opcr/Posted/${campusId}/${cycle}`);
    }
}